import { AppRestClient } from "@/util/rest/clients/app-rest-client";
import { z } from "zod";
import { ZodExtended } from "@/data/zod.extended";
import { ProjectsModels } from "./projects.models";
import { CommonModels } from "@/data/common/common.models";

export namespace ProjectsApi {
export const get = (limit: number, order?: string, filter?: CommonModels.ProjectPaginationFilterDto, page?: number, cursor?: string, ) => { 
    return AppRestClient.get( 
        { resSchema: ProjectsModels.ProjectsGetResponseSchema }, 
        `/projects`,
        {
    params: {
        order: ZodExtended.parse(z.string().nullish(), order, { type: "query", name: "order" })
, 
        filter: ZodExtended.parse(CommonModels.ProjectPaginationFilterDtoSchema.optional(), filter, { type: "query", name: "filter" })
, 
        limit: ZodExtended.parse(z.number().gte(1).lte(100).default(10), limit, { type: "query", name: "limit" })
, 
        page: ZodExtended.parse(z.number().nullish(), page, { type: "query", name: "page" })
, 
        cursor: ZodExtended.parse(z.string().nullish(), cursor, { type: "query", name: "cursor" })
, 
    },
}
    )
};

export const create = (data: ProjectsModels.CreateProjectDto, ) => { 
    return AppRestClient.post( 
        { resSchema: CommonModels.ProjectDtoSchema }, 
        `/projects`,
        ZodExtended.parse(ProjectsModels.CreateProjectDtoSchema, data)
, 
        
    )
};

export const getFeatured = () => { 
    return AppRestClient.get( 
        { resSchema: CommonModels.ProjectWithMediaDtoSchema }, 
        `/projects/featured`,
        
    )
};

export const requestUpload = (data: ProjectsModels.MediaUploadFileRequest, ) => { 
    return AppRestClient.post( 
        { resSchema: CommonModels.MediaUploadInstructionsSchema }, 
        `/projects/media/request-upload`,
        ZodExtended.parse(ProjectsModels.MediaUploadFileRequestSchema, data)
, 
        
    )
};

export const show = (id: string, ) => { 
    return AppRestClient.get( 
        { resSchema: CommonModels.ProjectDtoSchema }, 
        `/projects/${id}`,
        
    )
};

export const update = (id: string, data: ProjectsModels.UpdateProjectDto, ) => { 
    return AppRestClient.patch( 
        { resSchema: CommonModels.ProjectDtoSchema }, 
        `/projects/${id}`,
        ZodExtended.parse(ProjectsModels.UpdateProjectDtoSchema, data)
, 
        
    )
};

export const deleteProjectsById = (id: string, ) => { 
    return AppRestClient.delete( 
        { resSchema: CommonModels.ProjectDtoSchema }, 
        `/projects/${id}`,
        
    )
};

export const getMedia = (projectId: string, ) => { 
    return AppRestClient.get( 
        { resSchema: ProjectsModels.ProjectsGetMediaResponseSchema }, 
        `/projects/${projectId}/media`,
        
    )
};

export const deleteMedia = (projectId: string, mediaId: string, ) => { 
    return AppRestClient.delete( 
        { resSchema: ProjectsModels.ProjectMediaDeletedDtoSchema }, 
        `/projects/${projectId}/media/${mediaId}`,
        
    )
};

}
